<template>
  <v-row justify="center">
    <v-dialog
      v-model="show"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          :color="color"
        >
          <v-btn
            icon
            dark
            @click="hideDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <span v-text="subTitle" />
            History
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="hideDialog"
            >
              Close
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list
          three-line
          subheader
        >
          <v-list-item>
            <v-list-item-content>
              <slot name="header" />

              <v-progress-linear
                v-if="loading"
                indeterminate
              />

              <div
                v-if="!loading && (!records || !records.length)"
              >
                <h1>No Changes Recorded</h1>
              </div>
              <v-timeline
                v-if="records && records.length"
              >
                <v-timeline-item
                  v-for="(record, i) in records"
                  :key="i"
                  fill-dot
                >
                  <template v-slot:icon>
                    <v-avatar>
                      <img :src="avatarImg(record)">
                    </v-avatar>
                  </template>
                  <template v-slot:opposite>
                    <h3
                      v-for="(column, j) in columns"
                      :key="j"
                    >
                      <div class="mb-2">
                        <base-display-value
                          v-model="record[column.value]"
                          :label="column.text"
                          :data-type="column.dataType"
                        />
                      </div>
                    </h3>
                  </template>
                  <v-card
                    class="elevation-4"
                  >
                    <base-audit-container
                      :item="record"
                      prefer-update-only
                    />
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import md5 from 'md5'

  export default {
    props: {
      columns: {
        type: Array,
        default: () => ([
          {
            text: 'Unknown Field',
            value: 'field',
          },
        ]),
      },
      idField: {
        type: String,
        default: null,
      },
      titleField: {
        type: String,
        default: null,
      },
      item: {
        type: Object,
        default: null,
      },
      resourceEndpoint: {
        type: String,
        default: null,
      },
      color: {
        type: String,
        default: 'primary',
      },
    },

    data () {
      return {
        loading: false,
        records: null,
      }
    },

    computed: {
      subTitle () {
        return this.item ? this.item[this.titleField] : 'None'
      },

      show () {
        return this.item !== null
      },

      resource () {
        return new TroodyApi(this.resourceEndpoint)
      },
    },

    watch: {
      item: function (val) {
        this.fetchHistory(val)
      },

      resourceEndpoint: function () {
        this.fetchHistory(this.item)
      },
    },

    methods: {
      hideDialog () {
        this.$emit('hide')
      },

      fetchHistory (item) {
        this.loading = true
        this.records = null
        console.log('loading history for ' + this.resourceEndpoint)
        if (item) {
          const constraints = {}
          constraints[this.idField] = item.id
          this.resource.query(constraints)
            .then(data => {
              this.records = data
              this.loading = false
            })
            .catch((error) => {
              this.loading = false
              console.log(error)
            })
        }
      },

      avatarImg (historyItem) {
        const email = (historyItem.updatedByEmail || historyItem.createdByEmail || 'unknown@unknown.com')
        const img = [
          '//www.gravatar.com/avatar/',
          md5(email.trim().toLowerCase()),
          '?s=80', // 80 pixels
          '&d=mm', // Default (mystery man)
          '&r=pg', // PG Rating
        ]
        return img.join('')
      },

    },
  }
</script>
